import SuccessIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorIcon from "@mui/icons-material/ErrorOutline";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import WarnIcon from "@mui/icons-material/WarningAmberOutlined";
import { type SvgIconProps, type AlertColor } from "@mui/material";
import { ComponentType } from "react";

export interface SeverityOptionData {
  id: number;
  color: AlertColor;
  Icon: ComponentType<SvgIconProps>;
}

export const severityOptions = [
  { id: 0, color: "error", Icon: ErrorIcon },
  { id: 1, color: "warning", Icon: WarnIcon },
  { id: 2, color: "info", Icon: InfoIcon },
  { id: 3, color: "success", Icon: SuccessIcon },
] as SeverityOptionData[];
